// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpDisclosure } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const Disclosure = wrap(jpDisclosure(), {
    events: { onToggle: 'toggle' }
});
// @ts-expect-error unknown property
Disclosure.displayName = 'Jupyter.Disclosure';
